// extracted by mini-css-extract-plugin
export default {"block":"Address_block__+9tUJ","head":"Address_head__5Wjmp","map":"Address_map__yaJp3","title":"Address_title__-xND6","address":"Address_address__lY1W1","img":"Address_img__v57hA"};